export interface DaySection<T> {
  /** Local-timezone day key "YYYY-MM-DD"; null for items without a date (rendered headerless) */
  key: string | null
  items: Array<T>
}

const pad = (n: number): string => String(n).padStart(2, '0')

export const localDayKey = (isoDate: string): string | null => {
  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) return null
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

// Folds the server-sorted list into adjacent day sections — never re-sorts, so appended
// or prepended pages regroup correctly by re-running over the full array.
export const groupByDay = <T extends { date?: string | null }>(items: Array<T>): Array<DaySection<T>> => {
  const sections: Array<DaySection<T>> = []
  for (const item of items) {
    const key = item.date ? localDayKey(item.date) : null
    const last = sections[sections.length - 1]
    if (!last || last.key !== key) {
      sections.push({ key, items: [item] })
    } else {
      last.items.push(item)
    }
  }
  return sections
}
